<template>
    <div class="order-address-form__form-group-item">
        <label for="firm" class="control-label">
            <span class="label-text">
                Firma / Organisation
            </span>
            <span v-if="required" class="required-symbol"><span class="sr-only" lang="en">(Pflichtfeld)</span></span>
        </label>
        <input
            class="form-control"
            :class="{ 'error': required ? $parent.$v.form[$parent.address].company.$error : '' }"
            type="text"
            name="firm"
            v-model.trim="$parent.form[$parent.address].company"
            @input="required ? $parent.$v.form[$parent.address].company.$touch() : ''"
        >
    </div>
</template>

<script>
export default {
    props: {
        required: {
            type: Boolean,
            default: false,
        },
    },
};
</script>



// WEBPACK FOOTER //
// Firm.vue?732dd958